import IMask from "imask";
import {numberFormat} from "../helpers";

const _token = $('meta[name="csrf-token"]').attr('content');

export const quantityInput = () => {

    const min_val = 1;
    const max_val = 30;

    const $quantity__input = document.querySelectorAll('.quantity__input');
    const $quantity__input_wrap = $('.quantity__input');
    const $product__quantity = $('.product__quantity');
    const cart__total__price = $('.cart__total__price');
    const cart__subtotal__price = $('.cart__subtotal__price');
    const cart__delivery = $('.cart__delivery');
    const credit__price = $('.credit__price');
    const rate__price = $('.cart__rate');

    if ($quantity__input) {

        $quantity__input.forEach($input => {
            let quantityMask = new IMask($input, {
                mask: Number,
                min: min_val,
                max: max_val
            });
            $input.insertAdjacentHTML('beforebegin', '<button class="quantity__minus"></button>');
            $input.insertAdjacentHTML('afterend', '<button class="quantity__plus"></button>');
        });


        $product__quantity.on('click', '.quantity__plus', function (e) {
            e.preventDefault();
            let $input_val = $(this).parent().find('input');
            let value = parseInt($input_val.val());
            let id = $input_val.attr('data-id');
            let url = $input_val.attr('data-url');
            let translation = $input_val.attr('data-price-translation');
            let creditTranslation = $('.credit__price').attr('data-price-translation');
            let delivery = $('#delivery__region').val();
            let credit;

            if (value < max_val) {
                value++
                $input_val.val(value);
            }

            if ($('#credit').is(':checked')) {
                credit = 1;
            } else {
                credit = 0;
            }

            if (id) {
                //change qty
                $.ajax({
                    url: url,
                    type: "POST",
                    data: {
                        id: id,
                        qty: value,
                        credit: credit,
                        delivery: delivery,
                        _token: _token
                    },
                    success: function (data) {
                        changeNumber($input_val, $(".cart__list_item[data-id=" + id + "]"), value, translation);
                        cart__delivery.html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);
                        cart__subtotal__price.html(numberFormat(data.total, 0, '.', ' ') + ' ' + translation);
                        credit__price.html(numberFormat(data.rate, 2, '.', ' ') + ' ' + creditTranslation);
                        rate__price.html(numberFormat(data.credit, 2, '.', ' ') + ' ' + translation);

                        if (data.credit != 0) {
                            cart__total__price.html(numberFormat(data.subTotal, 2, '.', ' ') + ' ' + translation);
                        } else {
                            cart__total__price.html(numberFormat(data.subTotal, 0, '.', ' ') + ' ' + translation);
                        }
                    }
                });
            }
        });

        $product__quantity.on('click', '.quantity__minus', function (e) {
            e.preventDefault();
            let $input_val = $(this).parent().find('input');
            let value = parseInt($input_val.val());
            let id = $input_val.attr('data-id');
            let url = $input_val.attr('data-url');
            let translation = $input_val.attr('data-price-translation');
            let creditTranslation = $('.credit__price').attr('data-price-translation');
            let delivery = $('#delivery__region').val();
            let credit;

            if (value > min_val) {
                value--
                $input_val.val(value);
            }

            if ($('#credit').is(':checked')) {
                credit = 1;
            } else {
                credit = 0;
            }

            if (id) {
                //change qty
                $.ajax({
                    url: url,
                    type: "POST",
                    data: {
                        id: id,
                        qty: value,
                        credit: credit,
                        delivery: delivery,
                        _token: _token
                    },
                    success: function (data) {
                        changeNumber($input_val, $(".cart__list_item[data-id=" + id + "]"), value, translation);
                        cart__delivery.html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);
                        cart__subtotal__price.html(numberFormat(data.total, 0, '.', ' ') + ' ' + translation);
                        credit__price.html(numberFormat(data.rate, 2, '.', ' ') + ' ' + creditTranslation);
                        rate__price.html(numberFormat(data.credit, 2, '.', ' ') + ' ' + translation);

                        if (data.credit != 0) {
                            cart__total__price.html(numberFormat(data.subTotal, 2, '.', ' ') + ' ' + translation);
                        } else {
                            cart__total__price.html(numberFormat(data.subTotal, 0, '.', ' ') + ' ' + translation);
                        }
                    }
                });
            }
        });

        $('#quantity:not(.no-controls)').each(function () {
            let $this = $(this);
            $this.on('change', function (e) {
                e.preventDefault();
                let $input = $(this);
                let value = parseInt($input.val());

                if (value < 1 || value > 30 || $input.val() === "") {
                    value = 1;
                    return $input.val(value);
                }
            });
        });

        $('#quantity-cart:not(.no-controls)').each(function () {
            let $this = $(this);

            if ($this.parent().is('.cart__list_item')) {
                return;
            }
            $this.on('change', function (e) {
                e.preventDefault();
                let $input = $(this);
                let id = $input.attr('data-id');
                let url = $input.attr('data-url');
                let value = parseInt($input.val());
                let translation = $input.attr('data-price-translation');
                let creditTranslation = $('.credit__price').attr('data-price-translation');
                let delivery = $('#delivery__region').val();
                let credit;

                if (value < 1 || value > 30 || $input.val() === "") {
                    value = 1;
                    changeNumber($input, $(".cart__list_item[data-id=" + id + "]"), value, translation);
                }

                if ($('#credit').is(':checked')) {
                    credit = 1;
                } else {
                    credit = 0;
                }

                //change qty
                delay(function () {
                    $.ajax({
                        url: url,
                        type: "POST",
                        data: {
                            id: id,
                            credit: credit,
                            qty: value,
                            delivery: delivery,
                            _token: _token
                        },
                        success: function (data) {
                            changeNumber($input, $(".cart__list_item[data-id=" + id + "]"), value, translation);
                            cart__delivery.html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);
                            cart__subtotal__price.html(numberFormat(data.total, 0, '.', ' ') + ' ' + translation);
                            credit__price.html(numberFormat(data.rate, 2, '.', ' ') + ' ' + creditTranslation);
                            rate__price.html(numberFormat(data.credit, 2, '.', ' ') + ' ' + translation);

                            if (data.credit != 0) {
                                cart__total__price.html(numberFormat(data.subTotal, 2, '.', ' ') + ' ' + translation);
                            } else {
                                cart__total__price.html(numberFormat(data.subTotal, 0, '.', ' ') + ' ' + translation);
                            }
                        }
                    });
                }, 100);
            });
        });
    }

    function changeNumber(input, prodLine, value, translation) {
        input.val(value);
        let price = input.data('price');
        prodLine.find('.cart__list_item_price').text(numberFormat(price * value, 0, '.', ' ') + ' ' + translation);
    }
};

export const phoneInputMask = () => {

    const $phone__inputs_md = document.querySelectorAll('.phone__input_md');
    const $phone__inputs_ro = document.querySelectorAll('.phone__input_ro');

    // console.log($phone__inputs)

    if ($phone__inputs_md) {
        $phone__inputs_md.forEach($input => {
            let quantityMask = new IMask($input, {
                mask: '+373  00 00 00 00',
                placeholderChar: 'X',
                lazy: false,
            });
        });
    }
    if ($phone__inputs_ro) {
        $phone__inputs_ro.forEach($input => {
            let quantityMask = new IMask($input, {
                mask: '+4\\0 000 000 000',
                placeholderChar: 'X',
                lazy: false,
            });
        });
    }

};
